import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import PositionCard from '../components/PositionCard/PositionCard';
import StudentCard from '../components/StudentCard/StudentCard';
import PositionModal from '../components/PositionCard/PositionModal';
import { AuthContext } from '../context/AuthContext';

export default function SavedPage() {
  const { userRole } = useContext(AuthContext);
  const [savedItems, setSavedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const pageSize = 12;

  // Retrieve userId and token from localStorage
  const userData = JSON.parse(localStorage.getItem('user')) || {};
  const token = userData.token;
  const userId = userData.id || userData._id;

  useEffect(() => {
    if (!token || !userId) return;

    const fetchSaved = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/saved/${userId}`);
        setSavedItems(res.data.savedItems);
      } catch (err) {
        console.error('Error fetching saved items:', err);
      }
    };

    fetchSaved();
  }, [token, userId]);

  // Handler for when a card toggles save state
  const handleToggleSave = (itemId, isNowSaved) => {
    if (!isNowSaved) {
      // If unsaved, remove from list
      setSavedItems(prev => prev.filter(item => item._id !== itemId));
    }
    // If saved, you could optionally re-fetch or append, but not needed here
  };

  // Handler for viewing position details
  const handlePositionView = (position) => {
    setSelectedPosition(position);
  };

  // Handler for closing position modal
  const handleCloseModal = () => {
    setSelectedPosition(null);
  };

  // Pagination logic
  const totalPages = Math.ceil(savedItems.length / pageSize);
  const startIdx = (currentPage - 1) * pageSize;
  const paginated = savedItems.slice(startIdx, startIdx + pageSize);

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Saved {userRole === 'student' ? 'Positions' : 'Students'}
      </h1>

      {paginated.length === 0 ? (
        <p className="text-center text-gray-600">
          No saved {userRole === 'student' ? 'positions' : 'students'} found.
        </p>
      ) : (
        <>
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {paginated.map(item => (
              userRole === 'student' ? (
                <PositionCard
                  key={item._id}
                  position={item}
                  onView={() => handlePositionView(item)}
                  onToggleSave={handleToggleSave}
                />
              ) : (
                <StudentCard
                  key={item._id}
                  student={item}
                  onView={() => {/* navigate to student profile */}}
                  onToggleSave={handleToggleSave}
                />
              )
            ))}
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-center mt-6 gap-4">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
            >
              Previous
            </button>
            <span className="px-4 py-2">
              {`Page ${currentPage} of ${totalPages}`}
            </span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* Position Detail Modal */}
      <PositionModal
        position={selectedPosition}
        isOpen={!!selectedPosition}
        onClose={handleCloseModal}
      />
    </div>
  );
}
